export default __webpack_public_path__ + "static/media/scan-bunifikasi-picturemark-l.1ed9d8de.svg";